import { z } from 'zod'

/**
 * 추천 API 계약 (BIZ-75). 내 추천 코드·공유 링크·실적 조회.
 * 귀속·보상은 가입 시 서버가 처리하므로(auth signup의 referralCode) 여기엔 조회만 둔다.
 */
export const referralSummaryResponse = z.object({
  code: z.string(),
  link: z.string(), // 공유용 가입 링크(…/signup?ref=CODE)
  referredCount: z.number().int(),
  rewardPoints: z.number().int(), // 추천으로 받은 포인트 합
})
export type ReferralSummaryResponse = z.infer<typeof referralSummaryResponse>

/**
 * 가입 화면 추천 코드 해석 (BIZ-132). 공개 엔드포인트 — 코드 존재·만료 여부 + 초대자 표시명.
 * 표시명은 조직명 우선(개인 주체는 회사명 = 본인 이름), 소속이 없으면 유저 이름.
 */
export const referralResolveResponse = z.object({
  valid: z.boolean(),
  inviterName: z.string().nullable(), // invalid면 null
})
export type ReferralResolveResponse = z.infer<typeof referralResolveResponse>

/**
 * 추천 초대 발송 (BIZ-132). 내 추천 코드로 지인(비회원) 휴대폰에 초대 메시지를 보낸다.
 * 아직 알림톡 미등록이라 문자로 나가고, 승인되면 알림톡으로 승격.
 */
export const referralInviteRequest = z.object({
  phone: z.string().regex(/^01[016789][0-9]{7,8}$/, '휴대폰 번호를 확인해 주세요'),
})
export type ReferralInviteRequest = z.infer<typeof referralInviteRequest>

/** ok=false면 reason으로 사유(RATE_LIMITED·DUPLICATE·DISABLED)를 준다. */
export const referralInviteResponse = z.object({
  ok: z.boolean(),
  reason: z.enum(['RATE_LIMITED', 'DUPLICATE', 'DISABLED']).optional(),
})
export type ReferralInviteResponse = z.infer<typeof referralInviteResponse>
